import React from "react";
import PropTypes from "prop-types";
import state from "../../state";

import { MyDraggable as Draggable } from "../../components/Core";
import HoverBar from "../../components/HoverBar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container, Row, Col } from "reactstrap";
import { inlineElements, generateStyle, setOverLay, l } from "../../functions";
import { dummyProduct } from "../../consts/products";
import Icon from "../../components/Icons";
import { connect } from "react-redux";
import isEqual from "lodash/isEqual";

function mapStateToProps(state) {
  return {
    settings: state.rootReducer?.appearanceSettings || {},
  };
}
class ProductTitle extends React.Component {
  constructor(props) {
    super(props);
  }
  shouldComponentUpdate(nextProp, nextState) {
    if (
      !isEqual(this.props?.payload, nextProp?.payload) ||
      !isEqual(this.props?.settings, nextProp?.settings)
    ) {
      return true;
    }

    return false;
  }

  _initTitle = () => {
    let { payload } = this.props;

    if (payload === null) payload = this.props.options.payload;

    const { titleTag } = payload.datas || [];

    const MyComponent = titleTag || "h1";
    const cssSettings = generateStyle(payload, "container");
    const cssSettingsText = generateStyle(
      payload,
      "text",
      MyComponent.toUpperCase()
    );

    return (
      <Container fluid={payload.fullContainer} style={cssSettings}>
        {setOverLay(payload)}
        <Row>
          <Col xs={12} className="fullcol" style={cssSettingsText}>
            <MyComponent style={cssSettingsText}>
              {dummyProduct.name}
            </MyComponent>
          </Col>
        </Row>
      </Container>
    );
  };

  render() {
    const {
      dropzoneID,
      parentID,
      showBasicContent,
      showPreview,
      id,
      dropzoneProps,
      payload,
      options,
      ...rest
    } = this.props;

    if (showBasicContent) {
      const elements = state.getStorableState();
      let inDrop = false;

      if (Array.isArray(elements) && elements.length > 0) {
        const inlinedElements = inlineElements(elements);
        if (Array.isArray(inlinedElements) && inlinedElements.length > 0) {
          inlinedElements.forEach((element) => {
            if (element.type === this.props.type) inDrop = true;
          });
        } else inDrop = false;
      } else inDrop = false;

      return (
        <Draggable {...this.props} side={true}>
          <span>
            {(Array.isArray(rest.icon) && (
              <FontAwesomeIcon icon={rest.icon} />
            )) || <Icon icon={rest.icon} />}
            <span>{l(rest.name)}</span>
            {(inDrop && <span className="added">{l("Added")}</span>) || (
              <span className="required">{l("Required")}</span>
            )}
          </span>
        </Draggable>
      );
    }

    if (showPreview) {
      return <div>{this._initTitle()}</div>;
    }

    return (
      <Draggable {...this.props} minify={true}>
        <HoverBar
          datas={this.props}
          style={payload}
          parent={parentID}
          element={{ id, dropzoneID, parentID, payload }}
        />
        {this._initTitle()}
      </Draggable>
    );
  }
}

ProductTitle.propTypes = {
  id: PropTypes.string.isRequired,
  showBasicContent: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(ProductTitle);
